<template>
    <div class="row text-left">
        <div class="col-12 col-sm-6 col-md-8">
            <div class="row">
                <div class="col-sm-10 col-md-7">
                    <h4>{{ __('payments.Payment with Paypal') }}</h4>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12 col-sm-10 col-md-7">
                    <h5>{{ __('payments.Select Country') }}</h5>
                    <div class="form-group">
                        <div class="radio">
                            <label class="cr-styled" for="country_br">
                                <input type="radio" id="country_br" v-model="country" name="country" value="brazil"/>
                                <i class="fa"></i>
                                Brasil
                            </label>
                        </div>
                        <div class="radio">
                            <label class="cr-styled" for="country_other">
                                <input type="radio" id="country_other" v-model="country" name="country" value="other"/>
                                <i class="fa"></i>
                                {{ __('payments.Other Country') }}
                            </label>
                        </div>
                        <span v-if="country_err" class="text-danger">{{ __('payments.Select Country Alert') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
            <div class="card">
                <div class="card-header bg-light">
                    <h4>{{ __('payments.Confirm Payment') }}</h4>
                </div>
                <div class="card-body">
                    <h4>USD {{ value }}</h4>
                    <h5>{{ __('payments.' + plan.description) }}</h5>
                    <div class="row mt-4 mb-4">
                        <div class="col-12">
                            <label for="discount">{{ __('payments.Use Discount') }}</label>
                            <div class="input-group">
                                <input type="text" name="discount_code" class="form-control" v-model="discount_code" />
                                <span class="input-group-btn">
                                    <button @click="verifyDiscountCode" class="btn btn-light" type="button" id="discount-submit-paypal">{{ __('payments.Apply') }}</button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <button @click="submit()" type="button" class="btn btn-lg btn-block btn-success">{{ __('payments.Submit Payment') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['plan'],
    data() {
        return {
            country: null,
            discount_code: '',
            value: this.plan.value,
            discount_obj: null,
            country_err: false,
        };
    },
    methods: {
        verifyDiscountCode() {
            axios.post('discount-code', {discount_code: this.discount_code, value: this.plan.value})
                .then(result => {
                    if (result) {
                        this.value = result.price_final;
                        this.$toast.success('Código de desconto aplicado com sucesso!');
                    } else {
                        this.$toast.error('Código inválido ou inexistente!');
                    }
                });
        },
        submit() {
            if (!this.country) {
                this.country_err = true;
            } else {
                axios.post('submit-payment', {
                    fk_plan: this.plan.id,
                    discount_code: this.discount_code,
                    country: this.country,
                    method: 'paypal'})
                    .then(result => {
                        if (result.redirect) {
                            location.href = result.redirect;
                        }
                });
            }
        }
    }
}
</script>

<style>

</style>